// Module
var code = `<div appHeaderBar>
    <header-bar-title>More</header-bar-title>
</div>

<app-page-content [showWebFooter]="false" [usePagePadding]="true">
    <app-moo-menu></app-moo-menu>
</app-page-content>`;
// Exports
module.exports = code;